import { IconCrown, IconRosette } from '@tabler/icons-react'
import { cn } from '@/lib/cn'

/** Staff markers: moderator vs admin use different glyphs and colors. */

export function StaffRoleIcon({
  role,
  className,
}: {
  role: string | undefined | null
  className?: string
}) {
  const r = (role ?? 'user').toLowerCase()

  if (r === 'admin') {
    return (
      <span
        title="Administrator"
        aria-label="Administrator"
        className={cn('inline-flex shrink-0 align-middle leading-none', className)}
      >
        <IconCrown stroke={1.75} aria-hidden className="size-[1.125rem] text-amber-600 drop-shadow-sm" />
      </span>
    )
  }

  if (r === 'moderator') {
    return (
      <span title="Moderator" aria-label="Moderator" className={cn('inline-flex shrink-0 align-middle leading-none', className)}>
        <IconRosette stroke={1.75} aria-hidden className="size-[1.125rem] text-violet-600 drop-shadow-sm" />
      </span>
    )
  }

  return null
}
